import produce from 'immer';
import * as actionTypes from './actionTypes';

const defaultState = {
  data: [],
  current_page: 1,
  total_pages: null,
  id: null,
  details: null
}

const discounts = produce((draft, {type, payload}) => {
  const newState = draft;

  switch (type) {
    case actionTypes.GET_DISCOUNTS_SUCCESS:
      newState.data = payload.items;
      newState.current_page = payload.current_page;
      newState.total_pages = payload.total_pages;
      break;

    case actionTypes.SET_DISCOUNT_ID:
      newState.id = payload
      break;
    
    case actionTypes.GET_SINGLE_DISCOUNT_SUCCESS:
      newState.details = payload
      break;

    default:
  }
}, defaultState);

export default discounts;
